// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const ColumnOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M15 5v14M9 5v14M4 5h16c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1H4a1 1 0 01-1-1V6c0-.6.4-1 1-1z","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","stroke":"currentColor"}}]},"name":"column","theme":"outlined"};

const ColumnOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={ColumnOutlinedSvg} />;
  ColumnOutlined.displayName = 'ColumnOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(ColumnOutlined);
